import { render } from "./calendar-selector.vue?vue&type=template&id=f2788090"
import script from "./calendar-selector.vue?vue&type=script&lang=js"
export * from "./calendar-selector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__